import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import CreateShowIcon from '@material-ui/icons/Add'
import OpenShowIcon from '@material-ui/icons/Check'
import EditShowIcon from '@material-ui/icons/Ballot'
import DeleteShowIcon from '@material-ui/icons/DeleteForever'
import FilterShowsIcon from '@material-ui/icons/FilterList'
import SortIcon from '@material-ui/icons/SortByAlpha'
import SaveIcon from '@material-ui/icons/SaveAlt'

import PaperBlock from "../../ui/PaperBlock"

/**
 * shows
 * selected 
 * filters
 * filter
 * 
 * orderByDateConditions
 * orderByDate
 * onCreateShowClick = {} 
 * onOpenShowClick = {show} 
 * onEditShowClick = {show} 
 * onDeleteShowClick = {show}
 * onSelectFilter = {filter}
 * onSelectOrderByDate = {orderMode}
 * onSaveClick()
 */

class ControlPanel extends Component {

	state = {
		filterMenuAnchorEl: null,
		orderByDateMenuAnchorEL: null,
	}

	render() {
		
		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Создать шоу"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateShowClick === "function") {
							this.props.onCreateShowClick()
						}
					}}
				>
					<CreateShowIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Работать с шоу"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onOpenShowClick === "function") {
							this.props.onOpenShowClick(this.props.selected)
						}
					}}
				>
					<OpenShowIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать шоу"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditShowClick === "function") {
							this.props.onEditShowClick(this.props.selected)
						}
					}}
				>
					<EditShowIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить шоу"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteShowClick === "function") {
							this.props.onDeleteShowClick(this.props.selected)
						}
					}}
				>
					<DeleteShowIcon />
				</Button>
			</div></Tooltip>

			{/* Фильтры */}

			<Tooltip title = {this.props.filter ? `Фильтр: ${this.props.filter.title}` : "Фильтр"}>
				<div>
					<Button
						aria-owns = {this.state.filterMenuAnchorEl ? 'simple-menu' : null}
						aria-haspopup = "true"
						onClick = {e => {
							e.stopPropagation()
							this.setState({
								filterMenuAnchorEl: e.currentTarget
							})
						}}
					>
						<FilterShowsIcon />
					</Button>
				</div>
			</Tooltip>

			<Menu
				id = "simple-menu"
				anchorEl = {this.state.filterMenuAnchorEl}
				open = {Boolean(this.state.filterMenuAnchorEl)}
				onClose = {() => {
					this.setState({
						filterMenuAnchorEl: null
					})
				}}
			>

				{this.props.filters.map((filter, n) => {
					return <MenuItem
						selected = {filter.value === this.props.filter.value}
						key = {n}
						onClick = {e => {
							e.stopPropagation()
							this.setState({
								filterMenuAnchorEl: null
							}, () => {
								if (typeof this.props.onSelectFilter === "function") {
									this.props.onSelectFilter(filter)
								}
							})
						}}
					>
						{filter.title}
					</MenuItem>
				})}

			</Menu>
			
			{/* Сортировка по дате */}

			<Tooltip title = {this.props.orderByDate ? `Сортировка: ${this.props.orderByDate.title}` : "Сортировка"}>
				<div>
					<Button
						aria-owns = {this.state.orderByDateMenuAnchorEL ? 'simple-menu' : null}
						aria-haspopup = "true"
						onClick = {e => {
							e.stopPropagation()
							this.setState({
								orderByDateMenuAnchorEL: e.currentTarget
							})
						}}
					>
						<SortIcon />
					</Button>
				</div>
			</Tooltip>

			<Menu
				id = "simple-menu"
				anchorEl = {this.state.orderByDateMenuAnchorEL}
				open = {Boolean(this.state.orderByDateMenuAnchorEL)}
				onClose = {() => {
					this.setState({
						orderByDateMenuAnchorEL: null
					})
				}}
			>

				{this.props.orderByDateConditions.map((order, n) => {
					return <MenuItem
						selected = {order.value === this.props.orderByDate.value}
						key = {n}
						onClick = {e => {
							e.stopPropagation()
							this.setState({
								orderByDateMenuAnchorEL: null
							}, () => {
								if (typeof this.props.onSelectOrderByDate === "function") {
									this.props.onSelectOrderByDate(order)
								}
							})
						}}
					>
						{order.title}
					</MenuItem>
				})}

			</Menu>

			{/* Сохранение */}

			<Tooltip title = "Сохранить">
				<div>
					<Button
						disabled = {!(this.props.shows && this.props.shows.length)}
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onSaveClick === "function") {
								this.props.onSaveClick()
							}
						}}
					>
						<SaveIcon />
					</Button>
				</div>
			</Tooltip>			

		</PaperBlock>

	}

}

export default ControlPanel
